export default "__VITE_ASSET__KIN0m9MS__"